import axios from 'axios';
import showModal from '../components/ui/modals/showModal';

// Utwórz instancję axios
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
});

// ➕ INTERCEPTOR REQUEST – dodaje token do każdego żądania
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // ➕ Dodaj nagłówek X-Requested-With do każdego żądania
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  },
  error => Promise.reject(error)
);

// ➖ INTERCEPTOR RESPONSE – reaguje na błędy (401 = wyloguj)
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    if (error.response?.status === 403 && error.response.data?.requiresConsent) {
      window.location.href = '/consent-required';
    }
        // 💥 Obsługa błędu 429 - Too Many Requests
    if (error.response?.status === 429) {
      showModal('Za dużo żądań. Spróbuj ponownie za chwilę.', { type: 'error' });
    }

    return Promise.reject(error);
  }
);

export default instance;